import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin, Subscription } from 'rxjs';
import { IAsignatura, IDocente, IResDescargaArchivo, IResRegistroCalificaciones, ITabla, ITablaBody, ITablaBodyRow, ITablaCalificaciones, ITablaHeaders } from 'src/app/interfaces/calificaciones';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { RegistroCalificacionesService } from 'src/app/services/registro-calificaciones/registro-calificaciones.service';
import { WebSocketService } from 'src/app/services/web-socket/web-socket.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-seleccion-calificacion',
  templateUrl: './seleccion-calificacion.component.html',
  styleUrls: ['./seleccion-calificacion.component.scss']
})
export class SeleccionCalificacionComponent {
  tablaCalificaciones: ITablaCalificaciones | null = null
  asignatura: IAsignatura | null = null
  docentes: IDocente[] = []
  infoModalTitulo: string = ''
  infoModalTexto: string = ''
  configuracion: any
  configuracionFiltros: any = {}

  showCp: boolean = true
  showCe: boolean = true

  registrosGuardados: boolean = false
  tablaCalificacionesRes: ITablaCalificaciones | null = null
  renderTablaCalificaciones: boolean = false
  alertaExito: string = ''
  registrosEditables: boolean = false
  registrosModificados: boolean = false

  private intervalEstadoAlumnos: any;

  eventoNotasSubscription: Subscription | null = null;
  eventoEstadoAlumnosSubscription: Subscription | null = null;

  arrNotasPorEnviar: any = []
  loadingSocket: boolean = false;

  constructor (
    private router: Router,
    private _registroCalificaciones: RegistroCalificacionesService,
    private spinner: NgxSpinnerService,
    private webSocketService: WebSocketService,
    private _perfilamiento: PerfilamientoService
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if (routerData?.filtros) {
      this.configuracionFiltros = routerData.filtros;
    }

    if ( routerData?.tablaCalificaciones && routerData?.configuracion ) {
      this.tablaCalificaciones = routerData?.tablaCalificaciones
      this.asignatura = routerData?.asignatura
      this.docentes = routerData?.docentes
      this.configuracion = routerData?.configuracion
      this.registrosEditables = routerData?.editable
    } else {
      this.router.navigate(['/portal-calificacion'])
    }

    if (routerData?.tablaCalificaciones) {
      this.tablaCalificaciones = routerData?.tablaCalificaciones
    }
    this.obtenerCalificaciones()

    window.addEventListener('online', () => {
      this.conexionSocket()
      this.obtenerCalificaciones()
    });
    window.addEventListener('offline', ()=> {
      this.spinner.show()
    });
  }

  ngOnInit(): void {
    this.conexionSocket()

    this.webSocketService.connectionStatus$.subscribe((status: string) => {
      if ( status === 'closed' || status === 'error' || status === 'disconnected' ) {
        this.loadingSocket = true
        this.spinner.show()
      } else {
        if ( this.loadingSocket ) {
          this.loadingSocket = false
          this.spinner.hide()
        }
      }
    })

    this.intervalEstadoAlumnos = setInterval(() => {
      this.sendSocketInfoEstadoAlumnos()
    }, (environment.tiempoSocketEstadoAlumnos * 1000));
  }

  conexionSocket() {
    const websocketParams = {
      anyo: this.configuracion.anyo,
      periodoId: this.configuracion.periodoId,
      asignaturaId: this.configuracion.asignaturaId,
      sedeId: this.configuracion.sedeId,
      seccionId: this.configuracion.seccionId
    }
    this.webSocketService.initializeWebSocketConnection(websocketParams)
    this.eventoNotasSubscription = this.webSocketService.eventoNota$.subscribe((event: any) => {
      this.modificarNotaDesdeSocket(event)
    });

    this.eventoEstadoAlumnosSubscription = this.webSocketService.eventoEstadoAlumnosObs$.subscribe((event: any) => {
      this.modificarEstadoAlumnoDesdeSocket(event)
    });
  }

  modificarNotaDesdeSocket(event: any){
    if ( event.indexRow && event.indexBody ) {
      this.tablaCalificaciones!.body[event.indexBody].row[event.indexRow].valor = event.valor
      this.tablaCalificaciones!.body[event.indexBody].row[event.indexRow].nuevoValor = event.valor
    } else {
      const alumnoFiltrado = this.tablaCalificaciones?.body.find((alumno: ITablaBody) => alumno.alumnoId === event.alumnoId && alumno.idCs === event.idCs)
      if ( alumnoFiltrado ) {
        alumnoFiltrado.row.forEach((alumnoRow: ITablaBodyRow) => {
          if ( alumnoRow.tipoNota === event.tipoNota && alumnoRow.nroNota === event.nroNota ) {
            alumnoRow.valor = event.valor
            alumnoRow.nuevoValor = event.nuevoValor
          }
        })
      }
    }
  }

  modificarEstadoAlumnoDesdeSocket(event: any) {
    if ( event.alumnos ) {
      this.tablaCalificaciones?.body.forEach((alumno: ITablaBody) => {
        const alumnoEventFilter: any = event.alumnos.find((alumnoEvent: any) => alumno.alumnoId === alumnoEvent.alumnoId && alumno.idCs === alumnoEvent.idCs )
        if ( alumnoEventFilter ) {
          alumno.situacionFinal = alumnoEventFilter.situacionFinal
          alumno.row[alumno.row.length - 2].valor = alumnoEventFilter.situacionFinal

          if ( alumnoEventFilter.situacionFinal === 'RI' || alumnoEventFilter.situacionFinal === 'PP' ) {
            this.habilitarCpCeExSocket(alumno, false)
          } else {
            this.habilitarCpCeExSocket(alumno)
          }
        }
      })  
    }
  }

  sendSocketInfoEstadoAlumnos() {
    const websocketParams = {
      anyo: this.configuracion.anyo,
      periodoId: this.configuracion.periodoId,
      asignaturaId: this.configuracion.asignaturaId,
      sedeId: this.configuracion.sedeId,
      seccionId: this.configuracion.seccionId
    }
    let estadoAlumnosArr: any = []
    this.tablaCalificaciones?.body.forEach((alumno: any) => {
      estadoAlumnosArr = [
        ...estadoAlumnosArr, 
        {
          alumnoId: alumno.alumnoId,
          idCs: alumno.idCs,
          situacionFinal: alumno.situacionFinal
        }
      ]
    });
    let message = JSON.stringify({alumnos: estadoAlumnosArr})
    this.webSocketService.sendEstadosAlumnos(websocketParams, message)
  }

  habilitarCpCeExSocket(alumnoFiltrado: any, habilitar: boolean = true) {
    alumnoFiltrado.row.forEach((filaAlumnoFiltrado: ITablaBodyRow) => {
      if ( filaAlumnoFiltrado.tipoNota ) {
        alumnoFiltrado.editable = habilitar
        filaAlumnoFiltrado.editable = habilitar
        if ( !habilitar && filaAlumnoFiltrado.tipoNota !== 'AN' ) {
          filaAlumnoFiltrado.valor = '0,0'
          filaAlumnoFiltrado.nuevoValor = '0,0'
        } else if (filaAlumnoFiltrado.tipoNota === 'AN') {
          filaAlumnoFiltrado.valor = ''
          filaAlumnoFiltrado.nuevoValor = ''
        }
        this.registrosModificados = false
      }
    })
  }

  ngOnDestroy() {
    clearInterval(this.intervalEstadoAlumnos)
    this.webSocketService.disconnect()
  }

  volverAPortal(): void {
    this.router.navigate(['/visualizacion-seccion'], {
      state: {
        data: {
          configuracion: this.configuracion,
          filtros: this.configuracionFiltros,
          tablaCalificaciones: this.tablaCalificaciones,
          asignatura: this.asignatura,
          editable: this.registrosEditables
        }
      }
    })
  }

  validarVolver() {
    this.volverAPortal()
  }

  mostrarAlertaExito(texto: string) {
    this.alertaExito = texto
    setTimeout(() => {
      this.alertaExito = ''
    }, 3000);
  }

  obtenerCalificaciones(cierreCurso: boolean = false) {
    if ( !this.registrosGuardados ) {
      this.renderTablaCalificaciones = false
    }

    const $obtenerTabla = this._registroCalificaciones.getCalificaciones(this.configuracion)
    const $obtenerTablaInfo = this._registroCalificaciones.getCalificacionesTablaInfo(this.configuracion)
    /* const $obtenerTablaHeaders = this._registroCalificaciones.getCalificacionesTablaHeaders(this.configuracion)
    const $obtenerTablaSeccion = this._registroCalificaciones.getCalificacionesTablaSeccion(this.configuracion) */
    const $obtenerTablaHeaders = this._registroCalificaciones.getCalificacionesTablaHeaders(this.configuracion)
    const $obtenerTablaSeccion = this._registroCalificaciones.getCalificacionesTablaSeccion(this.configuracion)
    let res: any

    forkJoin([
      $obtenerTabla,
      $obtenerTablaHeaders,
      $obtenerTablaSeccion
    ]).subscribe(
      ([
        obtenerTabla,
        obtenerTablaHeaders,
        obtenerTablaSeccion
      ]) => {
        // res = obtenerTablaInfo
        res = {...obtenerTablaSeccion, ...obtenerTablaHeaders}
        res.tabla.body = obtenerTabla

        if ( res.asignatura ) {
          this.asignatura = res.asignatura
        }
        if ( res.docentes ) {
          this.docentes = res.docentes
        }
        if ( res.tabla ) {
          this.tablaCalificacionesRes = res.tabla
          this.tablaCalificaciones = res.tabla
          if ( this.registrosGuardados ) {
            this.renderTablaCalificaciones = false
            setTimeout(() => {
            this.renderTablaCalificaciones = true
            }, 500);
          } else {
            this.renderTablaCalificaciones = true
          }
        }
        if ( this.registrosGuardados ) {
          this.mostrarAlertaExito('Los cambios se han guardado correctamente.')
          this.registrosGuardados = false
        }
      }
    )
  }

  mostrarInfoModal(titulo: string, texto: string) {
    this.infoModalTitulo = titulo
    this.infoModalTexto = texto
    document.getElementById('btn-modal-info')?.click()
  }

  calificarAlumnos(header: ITablaHeaders, indexHeader: number) {
    const dataSeleccion = { header, indexHeader }
    this.router.navigate(['/ingreso-calificacion'], {
      state: {
        data: {
          tablaCalificaciones: this.tablaCalificaciones,
          filtros: this.configuracionFiltros,
          dataSeleccion: dataSeleccion,
          asignatura: this.asignatura,
          docentes: this.docentes,
          configuracion: this.configuracion,
          editable: this.registrosEditables
        }
      }
    })
  }

  alumnosSinCalifaciones(indexHeader: number) {
    let alumnosSinCalifaciones = 0
    this.tablaCalificaciones?.body.forEach((body: ITablaBody) => {
      body?.row.forEach((row: ITablaBodyRow, indexRow) => {
        if ( (indexRow === indexHeader) && row.editable && ( (row.hasOwnProperty("nuevoValor") && row.nuevoValor === '0,0') || (!row.hasOwnProperty("nuevoValor") && row.valor === '0,0') ) ) {
          alumnosSinCalifaciones++
        }
      }) // foreach row
    }) // foreach tablaBody
    return alumnosSinCalifaciones
  }

  saveAsXlsxFile ( base64: string, nombreArchivo: string ) {
    const mediaType="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"
    const file = base64
    let a = document.createElement('a')
    a.href = mediaType+file
    a.download = nombreArchivo+'.xlsx'
    a.click()
  }

  descargarRegistroCalificaciones() {
    this._registroCalificaciones.descargarRegistroCalificaciones(this.configuracion).subscribe(
      (res: IResDescargaArchivo) => {
        if ( res.error === null && res.archivo && res.nombreArchivo ) {
          this.saveAsXlsxFile(res.archivo, res.nombreArchivo)
        } else {
          this.mostrarInfoModal('Atención', res.error?.mensaje ? res.error.mensaje : 'Hubo un error en los servicios')
        }
      }
    )
  }

  validarNotasCompletas() {
    let notasCompletas = true
    this.tablaCalificaciones?.body.forEach((body: ITablaBody) => {
      if ( body.visible && body.editable ) {
        body.row.forEach((row: ITablaBodyRow) => {
          if ( row.valor === '0,0' && row.tipoNota !== 'EX' && row.editable ) {
            notasCompletas = false
          }
        })
      }
    })
    return notasCompletas
  }

  cerrarSeccion() {
    if ( this.validarNotasCompletas() ) {
      document.getElementById('modal-confirmar-cierre-seccion')?.click()
    } else {
      document.getElementById('modal-estudiantes-sin-calificaciones')?.click()
    }
  }

  confirmarCierreSeccion() {
    document.getElementById('btn-cerrar-modal-cierre-seccion')?.click()
    this._registroCalificaciones.postCierreSeccion(this.configuracion).subscribe(
      (res: IResRegistroCalificaciones) => {
        if ( res.error === null ) {
          this.registrosEditables = false
          this.mostrarAlertaExito('Se ha cerrado la sección con éxito.')
          this.router.navigate(['/visualizacion-seccion'], {
            state: {
              data: {
                configuracion: this.configuracion,
                filtros: this.configuracionFiltros,
                tablaCalificaciones: this.tablaCalificaciones,
                asignatura: this.asignatura,
                editable: this.registrosEditables
              }
            }
          })
        } else {
          this.mostrarInfoModal('Atención', res.error?.mensaje ? res.error.mensaje : 'No se pudo cerrar la sección')
        }
      }
    )
  }
}
